import { render, staticRenderFns } from "./inventoryIcon.vue?vue&type=template&id=c3a85926&scoped=true&"
import script from "./inventoryIcon.vue?vue&type=script&lang=js&"
export * from "./inventoryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a85926",
  null
  
)

export default component.exports